import React from 'react';
import {ModalHeader, Modal, Button, Row, Table, Container, Col} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import {DocumentEditField} from "./DocumentEditField";
import {FaCircleONotch, FaDownload} from "react-icons/lib/fa";

import DocumentService from "../../services/DocumentService";

//The API service is a self-contained static provider to talk to the certblock api
const documentService = new DocumentService();

export class DocumentManagementModal extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			show: props.show,
			orderPositionData: {
				orderNumber: props.orderNumber,
				deliveryNoteNumber: props.deliveryNoteNumber,
				orderPosition: props.orderPosition,
				documentProfiles: [],
				documents: []
			},
			orderNumber: props.orderNumber,
			deliveryNoteNumber: props.deliveryNoteNumber,
			orderPosition: props.orderPosition,
			pendingUploadEventHandler: {},
			pendingDeleteEventHandler: {},
			savingInProgress: false,
			fetchingOrderPositionData: false,
			downloadPackageInProgress: false,
			fetchUpdateCounter: 0,
			closeContainerCallback: props.closeContainerCallback,
			enableSerialNumberManagement: props.enableSerialNumberManagement,
			enableUpload: props.enableUpload
		};
	}

	componentDidMount() {
		this.fetchOrderPositionData();
	}

	/**
	 * This will fetch all the data from the order position. All serial number data etc.
	 * @return {Promise<void>}
	 */
	async fetchOrderPositionData() {
		let orderNumber = this.state.orderNumber;
		let deliveryNoteNumber = this.state.deliveryNoteNumber;
		let orderPosition = this.state.orderPosition;
		console.log("modal debug", orderNumber, deliveryNoteNumber, orderPosition);
		if(!orderNumber || !deliveryNoteNumber || !orderPosition) {
			//not ready yet.
			return;
		}
		this.setState({
			fetchingOrderPositionData: true
		});
		let orderPositionData = {
			orderNumber,
			deliveryNoteNumber,
			orderPosition,
			documentProfiles: await new Promise(async resolve => {
				let profiles = documentService.getConfiguredDocumentProfilesOfOrderPosition({
					orderNumber,
					orderPosition: orderPosition.id,
					deliveryNoteNumber
				});
				resolve(profiles);
			}),
			documents: await new Promise(resolve => {
				let uploadedDocuments = documentService.getAllDocumentsOfOrderPosition({
					orderNumber,
					orderPosition: orderPosition.id,
					deliveryNoteNumber
				})
				resolve(uploadedDocuments);
			}),
		}
		this.setState({
			orderPositionData,
			fetchingOrderPositionData: false,
			fetchUpdateCounter: this.state.fetchUpdateCounter + 1
		});
	}

	registerPendingUploadEventHandler({key, handler}) {
		let pendingUploadEventHandler = this.state.pendingUploadEventHandler;
		pendingUploadEventHandler[key] = handler;
		this.setState({
			pendingUploadEventHandler
		});
	}

	registerPendingDeleteEventHandler({key, handler}) {
		let pendingDeleteEventHandler = this.state.pendingDeleteEventHandler;
		pendingDeleteEventHandler[key] = handler;
		this.setState({
			pendingDeleteEventHandler
		});
	}

	async savePendingChanges() {
		this.setState({
			savingInProgress : true
		})
		let pendingUploadEventHandler = this.state.pendingUploadEventHandler;
		await Promise.all(Object.values(pendingUploadEventHandler).map(p => p()));
		let pendingDeleteEventHandler = this.state.pendingDeleteEventHandler;
		await Promise.all(Object.values(pendingDeleteEventHandler).map(p => p()));
		this.setState({
			savingInProgress : false
		})
		await this.fetchOrderPositionData();
	}

	async downloadAllDocuments() {
		this.setState({
			downloadPackageInProgress: true
		})
		await documentService.downloadAllDocuments({
			orderNumber: this.state.orderPositionData.orderNumber,
			deliveryNoteNumber: this.state.orderPositionData.deliveryNoteNumber,
			orderPosition: this.state.orderPositionData.orderPosition.id
		});
		this.setState({
			downloadPackageInProgress: false
		})
	}

	documentTableRow({documentProfiles, orderPositionSerialNumberEntry}) {
		return <tr key={`${this.state.orderPositionData.orderNumber}-${this.state.orderPositionData.deliveryNoteNumber}-${this.state.orderPositionData.orderPosition.id}-${orderPositionSerialNumberEntry.serialNumber}`}>
			<td>{orderPositionSerialNumberEntry.serialNumber}</td>
			{documentProfiles.map(profile => {
				let documentExists = (orderPositionSerialNumberEntry.documents.indexOf(profile.id) > -1);
				let documentExistsGlobally = !!this.state.orderPositionData.documents.find(doc => !doc.serialNumber && doc.documents.indexOf(profile.id) > -1);
				return <td className={`document-profile-${profile.id}`}>
					<DocumentEditField
						key={`${this.state.orderPositionData.orderNumber}-${this.state.orderPositionData.deliveryNoteNumber}-${this.state.orderPositionData.orderPosition.id}-${orderPositionSerialNumberEntry.serialNumber}-${profile.id}-${this.state.fetchUpdateCounter}`}
						orderNumber={this.state.orderPositionData.orderNumber}
						deliveryNoteNumber={this.state.orderPositionData.deliveryNoteNumber}
						orderPosition={this.state.orderPositionData.orderPosition.id}
						serialNumber={orderPositionSerialNumberEntry.serialNumber}
						documentProfileId={profile.id}
						documentExists={documentExists}
						documentExistsGlobally={documentExistsGlobally}
						registerPendingUploadEventHandler={(props) => this.registerPendingUploadEventHandler(props)}
						registerPendingDeleteEventHandler={(props) => this.registerPendingDeleteEventHandler(props)}
						enableDownload={true}
						enableUpload={this.state.enableUpload}
					/>
				</td>
			})}
		</tr>;
	}


	render() {
		return (
			<Modal animation={false} show={this.state.show}>
				<ModalHeader>
						<Modal.Title>
							{this.state.enableUpload ? <FormattedMessage id="searchDocuments.modalDownloadEditTitle"/> : <FormattedMessage id="searchDocuments.modalDownloadTitle"/>}
							 {this.state.orderPositionData?.orderPosition?.name}
						</Modal.Title>
				</ModalHeader>
				<Modal.Body id="modal-download-documents">
					<Container>
						<Row>
							<Table striped="columns">
								<thead>
								<tr>
									{this.state.enableSerialNumberManagement &&
										this.state.enableUpload ? <th>All SN Files</th> : <th></th>
									}
									{this.state.orderPositionData && this.state.orderPositionData.documentProfiles.map(profile => (
										<th className={`document-profile-${profile.id}`}
											key={`${this.state.orderPositionData.orderNumber}-${this.state.orderPositionData.deliveryNoteNumber}-${profile.id}`}>
											<Container>
												<Row className={"pb-3 pt-3"}>
													{profile.name}
												</Row>
												<Row>
													<DocumentEditField
														key={`${this.state.orderPositionData.orderNumber}-${this.state.orderPositionData.deliveryNoteNumber}-${this.state.orderPositionData.orderPosition.id}-${profile.id}-${this.state.fetchUpdateCounter}`}
														orderNumber={this.state.orderPositionData.orderNumber}
														deliveryNoteNumber={this.state.orderPositionData.deliveryNoteNumber}
														orderPosition={this.state.orderPositionData.orderPosition.id}
														documentProfileId={profile.id}
														documentExists={this.state.orderPositionData.documents.find(doc => !doc.serialNumber && doc.documents.indexOf(profile.id) > -1)}
														documentExistsGlobally={false}
														registerPendingUploadEventHandler={(props) => this.registerPendingUploadEventHandler(props)}
														registerPendingDeleteEventHandler={(props) => this.registerPendingDeleteEventHandler(props)}
														// ok, weird situation: We might have situations, where serial number management is enabled, but only global documents have been uploaded
														// in this scenario we need to render the download field, as long as even one document has been uploaded ,but no single document for a specific
														// serial number has been uploaded.
														enableDownload={!this.state.enableSerialNumberManagement || !(this.state.orderPositionData.documents.find(doc => doc.serialNumber))}
														enableUpload={this.state.enableUpload}
													/>
												</Row>
											</Container>
										</th>
									))}
								</tr>
								</thead>
								<tbody>
								{this.state.enableSerialNumberManagement && this.state.orderPositionData?.documents && this.state.orderPositionData.documents.filter(s => s.serialNumber).map(orderPositionSerialNumberEntry => this.documentTableRow({
									documentProfiles: this.state.orderPositionData.documentProfiles,
									orderPositionSerialNumberEntry
								}))}
								</tbody>
							</Table>
						</Row>
						<Row className={"flex-row-reverse"}>
							{this.state.fetchingOrderPositionData ? "" :
								<Button
									variant={"outline-success"}
									onClick={() => this.downloadAllDocuments()}>
									<FaDownload/>&nbsp;&nbsp;Download all
									{this.state.downloadPackageInProgress ? (<>&nbsp;&nbsp;<FaCircleONotch className={"spin"}/></>) : ""}
								</Button>
							}
						</Row>
					</Container>
				</Modal.Body>
				<Modal.Footer>
					{this.state.fetchingOrderPositionData ? (<>Updating data...&nbsp;&nbsp;<FaCircleONotch className={"spin"}/>&nbsp;&nbsp;</>) : ""}
					{this.state.enableUpload &&
						<Button
							variant={"success"}
							onClick={() => this.savePendingChanges()}>
							<FormattedMessage id="uploadDocuments.modalSerialNumberSaveButton"/>
							{this.state.savingInProgress ? (<>&nbsp;&nbsp;<FaCircleONotch className={"spin"}/></>) : ""}
						</Button>
					}
					<Button
						variant={"danger"}
						onClick={() => this.state.closeContainerCallback()}>
						<FormattedMessage id="uploadDocuments.modalSerialNumberCloseButton"/>
						{this.state.enableUpload ? <>/<FormattedMessage id="uploadDocuments.modalSerialNumberCancelButton"/></> : <></>}
					</Button>
				</Modal.Footer>
			</Modal>
		)
	}

}
